import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DpFormModule, DpHeaderModule, DpModalFormService, DpModalService, DpPaginationModule, DpSearchModule, DpTableModule } from '@docpath/webcomponents';
import { TranslateModule } from '@ngx-translate/core';

import {AliasComponent} from './alias.component';
import { AliasHeaderComponent } from './components/header/alias-header.component';
import { AliasTableComponent } from './components/table/alias-table.component';

@NgModule({
    declarations: [
        AliasTableComponent,
        AliasComponent,
        AliasHeaderComponent
    ],
    imports: [
      CommonModule,
      DpFormModule,
      DpHeaderModule,
      DpPaginationModule,
      DpSearchModule,
      DpTableModule,
      TranslateModule
    ],
    providers: [
      DpModalService,
      DpModalFormService
    ]
  })
  export class AliasModule { }
  